export const siteMinWidth = 1440;
export const menuItemHeight = 100;
export const menuItemWidth = 100;
export const topBarHeight = 100;
